var _title, _desc, _defs, _use, _rect, _rect2, _g, _g2, _use2, _g3, _rect3, _rect4, _rect5, _rect6, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPv = function SvgPv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "206px",
    height: "90px",
    viewBox: "0 0 206 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 5 Copy")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9775939%",
    cy: "37.2628945%",
    fx: "42.9775939%",
    fy: "37.2628945%",
    r: "60.600998%",
    gradientTransform: "translate(0.429776,0.372629),scale(1.000000,0.785714),rotate(36.976459),translate(-0.429776,-0.372629)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 66,
    height: 84,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 66,
    height: 84,
    rx: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.300000012,
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#575757",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 6,
    y: 23,
    width: 54,
    height: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 5,
    y: 16,
    width: 56,
    height: 2,
    rx: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 C11.1045695,0 12,0.8954305 12,2 C12,3.1045695 11.1045695,4 10,4 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 18,
    cy: 2,
    r: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(5.000000, 56.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 0,
    width: 56,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 20,
    width: 46,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 15,
    width: 56,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 10,
    width: 56,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 5,
    width: 56,
    height: 2,
    rx: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.300000012,
    transform: "translate(140.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-6"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#575757",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(6.000000, 54.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 5,
    y: 0,
    width: 44,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 10,
    y: 10,
    width: 34,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    x: 0,
    y: 5,
    width: 54,
    height: 2,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 6,
    y: 70,
    width: 54,
    height: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 6,
    y: 23,
    width: 24,
    height: 27
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 36,
    y: 23,
    width: 24,
    height: 27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: 5,
    y: 16,
    width: 56,
    height: 2,
    rx: 1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 C11.1045695,0 12,0.8954305 12,2 C12,3.1045695 11.1045695,4 10,4 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 18,
    cy: 2,
    r: 2
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(70.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#272C36",
    x: 0,
    y: 0,
    width: 66,
    height: 90,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F6F6F6",
    x: 6,
    y: 24,
    width: 54,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2,48.2 L21.2,55.4 L24.2,55.4 C25.192005,55.4 26.0399965,55.0480035 26.744,54.344 C27.4480035,53.6399965 27.8,52.792005 27.8,51.8 C27.8,50.807995 27.4480035,49.9600035 26.744,49.256 C26.0399965,48.5519965 25.192005,48.2 24.2,48.2 L21.2,48.2 Z M21.2,59.6 L21.2,63.8 L17,63.8 L17,44 L24.2,44 C26.3600108,44 28.1999924,44.7599924 29.72,46.28 C31.2400076,47.8000076 32,49.6399892 32,51.8 C32,53.9600108 31.2400076,55.7999924 29.72,57.32 C28.1999924,58.8400076 26.3600108,59.6 24.2,59.6 L21.2,59.6 Z M49.88,44 L42.656,63.8 L39.368,63.8 L32.144,44 L36.608,44 L41,56.048 L45.416,44 L49.88,44 Z",
    id: "PV",
    fill: "#232A36"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#F6F6F6",
    x: 5,
    y: 16,
    width: 56,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.000000, 8.000000)",
    fill: "#F6F6F6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 C11.1045695,0 12,0.8954305 12,2 C12,3.1045695 11.1045695,4 10,4 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    cx: 18,
    cy: 2,
    r: 2
  })))))));
};
export { SvgPv as ReactComponent };
export default "data:image/svg+xml;base64,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";